export function buildPromotionsListTableHeaders({ t, showActionsColumn = false }) {
  const headers = [
    {
      value: "id",
      text: t("page.users.id"),
      thClass: "w-24",
      tdClass: "max-w-[5rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "name",
      text: t("promotions.name"),
      thClass: "w-[14rem]",
      tdClass: "max-w-[14rem] min-w-[10rem]",
      disabled: true,
    },
    {
      value: "createdAt",
      text: t("promotions.createdAt"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "validityPeriod",
      text: t("promotions.validityPeriod"),
      thClass: "w-[14rem]",
      tdClass: "max-w-[16rem] min-w-[12rem]",
    },
    {
      value: "status",
      text: t("page.dealersCompany.status"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
  ];

  if (showActionsColumn) {
    headers.push({
      value: "buttons",
      label: t("page.users.buttons"),
      thClass: "w-[8rem]",
      tdClass: "max-w-[8rem] min-w-[8rem]",
      disabled: true,
    });
  }

  return headers;
}
